<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-gateway`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 24c0-9.941-8.059-18-18-18-7.989 0-14.762 5.205-17.114 12.408C5.768 19.78 2 24.45 2 30c0 6.627 5.373 12 12 12h14c9.941 0 18-8.059 18-18zm-31.312-4.35A14.007 14.007 0 0128 10c7.732 0 14 6.268 14 14s-6.268 14-14 14H14a8 8 0 01-8-8c0-3.642 2.457-6.8 5.921-7.728l2.094-.561.673-2.061zM28 17a7 7 0 012.001 13.71L30 34a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.29A7 7 0 0128 17zm-3 7a3 3 0 116 0 3 3 0 01-6 0z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconCloudGateway',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
